import { NhostClient } from "@nhost/nhost-js";
import { nhostSubdomain, nhostRegion } from "../environment-variables";

export const nhost = new NhostClient({
  subdomain: nhostSubdomain,
  region: nhostRegion,
});
